import React, { useState, useEffect } from "react";
import { Form } from "semantic-ui-react";
import { Integration } from "../../../../api";

const integrationController = new Integration();

// Acceso del usuario a la otra app Sustemia (Sustentable ↔ SH) y rol con el
// que entra allá. Solo aparece si la empresa tiene contratada la otra app.
// value: { enabled, roleName }. Se guarda aparte con saveUserPeerAccess.
export function PeerAccessFields({ accessToken, companyId, value, onChange, t }) {
  const [peer, setPeer] = useState(null);

  useEffect(() => {
    setPeer(null);
    if (!companyId) return;
    integrationController
      .getPeerRoles(accessToken, companyId)
      .then(setPeer)
      .catch(() => setPeer(null));
  }, [accessToken, companyId]);

  if (!peer?.enabled) return null;

  return (
    <Form.Group widths="equal">
      <Form.Checkbox
        label={`${t("access_to")} ${peer.name}`}
        checked={value.enabled}
        onChange={(_, data) => onChange({ ...value, enabled: data.checked })}
      />
      {value.enabled && (
        <Form.Dropdown
          label={`${t("role_in")} ${peer.name}`}
          placeholder={t("select")}
          selection
          options={peer.roles.map((name) => ({ key: name, text: name, value: name }))}
          value={value.roleName || ""}
          onChange={(_, data) => onChange({ ...value, roleName: data.value })}
        />
      )}
    </Form.Group>
  );
}

export function initialPeerAccess(user) {
  return {
    enabled: user?.peerAccess?.enabled === true,
    roleName: user?.peerAccess?.roleName || "",
  };
}

// Guarda el acceso solo si cambió. Devuelve un aviso para mostrar, o null.
export async function saveUserPeerAccess(accessToken, { user, email, initial, value }) {
  if (value.enabled === initial.enabled && value.roleName === initial.roleName) return null;
  const result = await integrationController.setUserAccess(accessToken, {
    userId: user?._id,
    email: user ? undefined : email,
    enabled: value.enabled,
    roleName: value.roleName,
  });
  return result.integrationWarning || null;
}
